export default "__VITE_ASSET__79a6ac88__"